// src/components/admin/PortfolioManager.js
import { useState } from 'react';
import { FiPlus, FiTrash2, FiExternalLink } from 'react-icons/fi';
import { useApiAuth } from '../../hooks/useApiAuth';
import { usePortfolio } from '../../hooks/usePortfolio';

function PortfolioManager() {
  const { portfolio, refresh } = usePortfolio();
  const { authFetch } = useApiAuth();
  const [title, setTitle] = useState('');
  const [url, setUrl] = useState('');
  const [description, setDescription] = useState('');
  const [adding, setAdding] = useState(false);

  async function handleAdd(e) {
    e.preventDefault();
    if (!title.trim() || !url.trim()) return;
    setAdding(true);
    try {
      await authFetch('/api/admin/portfolio', {
        method: 'POST',
        body: { title: title.trim(), url: url.trim(), description: description.trim() },
      });
      setTitle('');
      setUrl('');
      setDescription('');
      await refresh();
    } catch (err) {
      alert('Failed to add: ' + err.message);
    } finally {
      setAdding(false);
    }
  }

  async function handleRemove(id) {
    try {
      await authFetch('/api/admin/portfolio', {
        method: 'DELETE',
        body: { id },
      });
      await refresh();
    } catch (err) {
      alert('Failed to delete: ' + err.message);
    }
  }

  return (
    <section className="admin-section">
      <h2 className="admin-section-title">Portfolio</h2>

      <form className="admin-form admin-form--inline" onSubmit={handleAdd}>
        <div className="admin-field">
          <label className="admin-label">Site Title</label>
          <input className="admin-input" type="text" value={title} onChange={e => setTitle(e.target.value)} placeholder="My Client Site" required />
        </div>
        <div className="admin-field">
          <label className="admin-label">URL</label>
          <input className="admin-input" type="url" value={url} onChange={e => setUrl(e.target.value)} placeholder="https://example.com" required />
        </div>
        <div className="admin-field">
          <label className="admin-label">Description</label>
          <input className="admin-input" type="text" value={description} onChange={e => setDescription(e.target.value)} placeholder="Brief description of the project" />
        </div>
        <button className="admin-save-btn" type="submit" disabled={adding}>
          <FiPlus size={14} />
          {adding ? 'Adding…' : 'Add Site'}
        </button>
      </form>

      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Title</th>
              <th>URL</th>
              <th>Description</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {portfolio.map(p => (
              <tr key={p.id}>
                <td className="admin-td-name">{p.title}</td>
                <td>
                  <a href={p.url} target="_blank" rel="noopener noreferrer" className="admin-link">
                    {p.url} <FiExternalLink size={11} />
                  </a>
                </td>
                <td className="admin-td-body">{p.description}</td>
                <td>
                  <button className="admin-delete-btn" onClick={() => handleRemove(p.id)} aria-label="Delete entry">
                    <FiTrash2 size={14} />
                  </button>
                </td>
              </tr>
            ))}
            {portfolio.length === 0 && (
              <tr><td colSpan={4} className="admin-empty">No portfolio entries yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}

export default PortfolioManager;
